import type { RoundEvent } from "@slot/client-engine";
import type { GridEffect } from "@slot/presentation";
import type { BaseGridPresenter, GridPresenter } from "./GridPresenter";

/** The base layer plus the effect layers as one grid presenter: the frame goes to the base, a removal to all in parallel. */
export class CompositeGridPresenter implements GridPresenter {
  private readonly base: BaseGridPresenter;
  private readonly effects: readonly GridEffect[];

  public constructor(input: { base: BaseGridPresenter; effects: readonly GridEffect[] }) {
    this.base = input.base;
    this.effects = input.effects;
  }

  public presentEventFrame(event: RoundEvent): Promise<void> {
    return this.base.presentEventFrame(event);
  }

  /** In parallel: the base shrinks while an effect fades its dim; the removal is done when the longest is. */
  public async removeSymbolsByMask(positionMask: string): Promise<void> {
    await Promise.all([this.base, ...this.effects].map((layer) => layer.removeSymbolsByMask(positionMask)));
  }

  /** Spin-start teardown for the layers that hold transient win VFX. */
  public clearForNewSpin(): void {
    for (const layer of [this.base, ...this.effects]) layer.clearForNewSpin?.();
  }
}
